import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export type CategoryRowProps = {
    label: string;
    checked?: boolean;
    indeterminate?: boolean;
    open?: boolean;
    onChange?: () => void;
    onToggleOpen?: () => void;
    disabled?: boolean;
};

export function CategoryRow({
    label,
    checked = false,
    indeterminate = false,
    open,
    onChange,
    onToggleOpen,
    disabled,
}: CategoryRowProps): ReactElement {
    const { t } = useTranslation();
    return (
        <>
            {onToggleOpen && (
                <IconButton
                    size="small"
                    onClick={onToggleOpen}
                    aria-expanded={Boolean(open)}
                    aria-label={open ? t('ACTIONS.COLLAPSE', { label }) : t('ACTIONS.EXPAND', { label })}
                    sx={{ p: 0 }}>
                    <KeyboardArrowRightIcon
                        sx={{
                            transition: 'transform 0.2s',
                            transform: open ? 'rotate(90deg)' : undefined,
                        }}
                    />
                </IconButton>
            )}
            <FormControlLabel
                control={
                    <Checkbox checked={checked} indeterminate={indeterminate} onChange={onChange} disabled={disabled} />
                }
                label={label}
                sx={{ mr: 0 }}
            />
        </>
    );
}
